function updateCombinedVariant(sectionId, productId) {
  const variantIdInput = document.getElementById(`variant-id-${sectionId}-${productId}`);
  const submitButton = document.getElementById(`quick-add-${sectionId}-${productId}-submit`);
  const variants = window[`variants_${productId}`];

  const selectedOptions = [];

  // Get selected color
  const colorEl = document.querySelector(
    `.ambi-color-swatches[data-product-id="${productId}"][data-section-id="${sectionId}"] .ambi-color-swatch--selected`
  );
  if (colorEl) {
    selectedOptions.push(colorEl.dataset.colorValue);
  }

  // Get selected non-color swatches
  document
    .querySelectorAll(`.ambi-option-swatches[data-product-id="${productId}"][data-section-id="${sectionId}"]`)
    .forEach((container) => {
      const selected = container.querySelector('.ambi-option-swatch--selected');
      if (selected) {
        selectedOptions.push(selected.dataset.value);
      }
    });

  const matchingVariant = variants.find((v) => {
    return v.options.every((opt, i) => opt === selectedOptions[i]);
  });

  if (matchingVariant && variantIdInput) {
    variantIdInput.value = matchingVariant.id;

    if (submitButton) {
      if (matchingVariant.available) {
        submitButton.disabled = false;
        const text = submitButton.querySelector('span');
        if (text) text.textContent = submitButton.dataset.addToCartText || 'Add to cart';
        variantIdInput.disabled = false;
      } else {
        submitButton.disabled = true;
        const text = submitButton.querySelector('span');
        if (text) text.textContent = 'Sold out';
        variantIdInput.disabled = true;
      }
    }
  }
}
